import { withLastUpdated } from './withLastUpdated';
import { withProgressBar } from './withProgressBar';
import { withTitle } from './withTitle';
import type { PresetHOC } from '../types/PresetHOC';

export const withCommonCapabilities: PresetHOC<{
    showTitleAndDescription?: boolean;
    showLastUpdated?: boolean;
    showProgressBar?: boolean;
}> = (Visualization) =>
    withTitle(withProgressBar(withLastUpdated(Visualization)));
